module.exports = __webpack_public_path__ + "img/deloitte.1f3be88a.svg";